import { render, staticRenderFns } from "./header-product-review.vue?vue&type=template&id=414d638a&scoped=true&"
import script from "./header-product-review.vue?vue&type=script&lang=js&"
export * from "./header-product-review.vue?vue&type=script&lang=js&"
import style0 from "./header-product-review.vue?vue&type=style&index=0&id=414d638a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414d638a",
  null
  
)

export default component.exports